import { render, staticRenderFns } from "./demo2.vue?vue&type=template&id=209bdb1f&scoped=true"
import script from "./demo2.vue?vue&type=script&lang=js"
export * from "./demo2.vue?vue&type=script&lang=js"
import style0 from "./demo2.vue?vue&type=style&index=0&id=209bdb1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209bdb1f",
  null
  
)

export default component.exports